import React from "react";
import {observer} from "mobx-react-lite";
import ResidentAdminPage from "../../components/templates/residentAdmin/residentAdminPage";
import {useStores} from "../../stores/useStores";
import withRedirectWithoutASelectedVillage from "../../utils/auth/withRedirectWithoutASelectedVillage";

const ServicedApartmentResidentAdmin: React.FC = () => {
  const {
    domainStore: {servicedApartmentResidentAdminDomainStore},
    uiStore: {servicedApartmentResidentAdminUiStore}
  } = useStores();

  return (
    <ResidentAdminPage
      residentAdminDomainStore={servicedApartmentResidentAdminDomainStore}
      residentAdminUiStore={servicedApartmentResidentAdminUiStore}
      namespace="saresidentadmin"
    />
  );
};

export default withRedirectWithoutASelectedVillage(
  observer(ServicedApartmentResidentAdmin)
);
